import React, { useState, useEffect, useRef, useCallback } from "react";
import Profilepicture from "../../../assets/profilepicture.svg";
import Card from "../../components/card/Card";
import Button from "../../components/button/Button";
import dummy from "../../../assets/dummy.jpg";
import ReactQuill from "react-quill";
import Dialog from "@mui/material/Dialog";
import axios from "axios";
import { toast } from "react-toastify";
import Slide from "@mui/material/Slide";
import moment from "moment-timezone";
import UploadBox from "../../components/uploadbox/UploadBox";
import { useUserContext } from "../../../context/MemorialContext";
import { TiLeaf } from "react-icons/ti";
import { BsChatLeftHeart } from "react-icons/bs";
import { HiOutlineCake } from "react-icons/hi";
import { ProgressBar, ThreeDots } from "react-loader-spinner";
import { useParams } from "react-router";
import { Link, useLocation } from "react-router-dom";
import {
  Avatar,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Facebook, Mail, ContentCopy } from "@mui/icons-material";
import { SHA256 } from "crypto-js";
import editIcon from "../../../assets/edit.svg";
import { useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import "./Profile.css";
import { auth } from "../../../utils/firebaseConfig";
import { getAuthHeaders, authFetch, getBackendUrl, parseJsonSafe } from "../../../utils/memorialApi";
import MemorialGallery from "../../components/memorial/MemorialGallery";
import {
  MemorialPrivacySettings,
  MemorialPendingTributes,
  MemorialTransferSettings,
} from "../../components/memorial/MemorialSettings";
import GallerySlideshow from "../../components/gallery/GallerySlideshow";
import { getMemorialShareUrl, formatShareUrlForDisplay } from "../../../utils/memorialShareUrl";
import PendingTributesBanner from "../../components/notifications/PendingTributesBanner";
import { saveReturnUrl } from "../../../utils/pendingTributes";
import "../../components/gallery/GallerySlideshow.css";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const backendUrl = getBackendUrl();

const Profile = () => {
  const [secretHash, setSecretHash] = useState("");
  const { search } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const secret = searchParams.get("secret");
  const parse = require("html-react-parser");
  const audioRef = useRef(null);
  const dropdownRef = useRef(null);
  const [currentTab, setCurrentTab] = useState("about");
  const [value, setValue] = useState();
  const [owner, setOwner] = useState();
  const [currentMusic, setCurrentMusic] = useState();
  const { selectedTheme, user, setSelectedTheme } = useUserContext();
  const [accessWithToken, setAccessWithToken] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [memorial, setMemorial] = useState();
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nloading, setNLoading] = useState(false);
  const [loadingMusic, setMusicLoading] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);
  const [error, setError] = useState("");
  const [subMenu, setSubMenu] = useState("photo");
  const [tributeText, setTributeText] = useState("");
  const [isImgLoading, setIsImageLoading] = useState(false);
  const [isTributeLoading, setIsTributeLoading] = useState(false);
  const [editData, setEditData] = useState({});
  const [storyTitle, setStoryTitle] = useState("");
  const [storyTitle1, setStoryTitle1] = useState("");
  const [storyDesc, setStoryDesc] = useState("");
  const [storyDesc1, setStoryDesc1] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFile2, setSelectedFile2] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mainError, setMainError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [privacyLoading, setPrivacyLoading] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  /*usuario actual*/
  //const [currentUser, setCurrentUser] = useState(null);
  const { user: currentUser, fetchUser } = useUserContext();
  /*para la edición de comentarios en tributes*/
  const [isEditingId, setIsEditingId] = useState(null);
  const [editedDescription, setEditedDescription] = useState("");
  /*para my plan*/
  const [currentPlan, setCurrentPlan] = useState(null);
  const [currentPlanId, setCurrentPlanId] = useState(0);

const [availablePlans, setAvailablePlans] = useState([]);
const [isLoadingPlans, setIsLoadingPlans] = useState(false);

//para edición del about / life
const [editingLifeId, setEditingLifeId] = useState(null);
const [editingLifeTitle, setEditingLifeTitle] = useState("");
const [editingLifeDesc, setEditingLifeDesc] = useState("");

/*para direccion de envio*/
const [shippingAddress, setShippingAddress] = useState("");
  const [pendingTributeCount, setPendingTributeCount] = useState(0);
  const [pendingTributesList, setPendingTributesList] = useState([]);
  const initialTabApplied = useRef(false);

/*para gestonar success desde el pago de upgrade*/
/*useEffect(() => {
  const params = new URLSearchParams(location.search);
  const success = params.get("success");

  if (success) {
    console.log("✅ Pago completado con éxito. Verificando...");

    axios.get("/api/user/profile")
      .then((res) => {
        console.log("🔄 Perfil actualizado:", res.data);

        // ✅ Solo después de haber confirmado que hay un usuario:
        if (res.data && res.data.user) {
          navigate("/success");
        }
      })
      .catch((err) => {
        console.error("❌ Error al actualizar perfil post-pago", err);
        alert("Hubo un error al cargar tu perfil. Intenta nuevamente.");
      });
  }
}, [location.search, navigate]);*/

useEffect(() => {
  if (currentUser?.meta?._id) {
    fetchUser();
  }
}, []);
useEffect(() => {
  if (currentUser) {
    fetchAvailablePlans(); // 👈 carga los planes solo si el usuario ya está cargado
  }
}, [currentUser]);
 /* para la edición de comentarios en tributes */

const handleSaveEdit = async (tributeId) => {
  try {
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("Usuario no autenticado");
      return;
    }

    const token = await currentUser.getIdToken();

    const base = backendUrl || "http://localhost:5000";
    const res = await fetch(`${base.replace(/\/$/, "")}/api/tributes/${tributeId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // 👈 TOKEN agregado aquí
      },
      body: JSON.stringify({ description: editedDescription }),
    });

    if (res.ok) {
      setIsEditingId(null);
      window.location.reload(); // o actualizar el estado si lo manejas así
    } else {
      throw new Error("Error al actualizar tributo");
    }
  } catch (err) {
    console.error("Error actualizando tributo:", err);
  }
};
/* fin para la edición de comentarios en tributes */

/*para obtener el usuario

useEffect(() => {
  const auth = getAuth();

  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      user.getIdToken().then((token) => {
        const base = backendUrl || "http://localhost:5000";
        fetch(`${base.replace(/\/$/, "")}/api/user/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("RESPONSE DE /api/user/profile:", data);
            if (data && data._id) {
              fetchUser(); 
              
              fetchAvailablePlans();
            } else {
              console.warn("No se encontró el usuario en la respuesta");
              
            }
          })
          .catch((err) => {
            console.error("Error obteniendo usuario desde backend:", err);
            
          });
      });
    } else {
      
    }
  });

  return () => unsubscribe();
}, []);
*/


const { id: memorialId } = useParams();

// Centralizar fetch
/*const fetchMemorial = useCallback(async () => {
  if (!memorialId) return;

  try {
    const response = await fetch(`/api/memorials/${memorialId}`);
    if (!response.ok) throw new Error("Failed to fetch memorial");
    const data = await response.json();
    console.log("🎯 Fetched updated memorial:", data);
    setMemorial(data);
  } catch (error) {
    console.error("Error fetching memorial:", error);
  }
}, [memorialId]);*/

  /*fin*/

  /*Este endpoint devolverá los planes guardados en MongoDB (desde el modelo Plan.js).*/
  const fetchAvailablePlans = async () => {
  try {
    const base = backendUrl || "http://localhost:5000";
    const response = await fetch(`${base.replace(/\/$/, "")}/api/plans`);
    if (!response.ok) throw new Error("Failed to fetch plans");
    const data = await response.json();
    setAvailablePlans(data);
  } catch (error) {
    console.error("Error fetching available plans:", error);
  }
  };

  const handleSavePreferences = () => {
    setNLoading(true);
    const updatedNotification = !isChecked3
      ? {
          post: isChecked,
          birthday: isChecked1,
          passed: isChecked2,
          emailSent: false,
        }
      : {
          post: false,
          birthday: false,
          passed: false,
          emailSent: false,
        };

    fetch(`${backendUrl}/api/memorials/notifications/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedNotification),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Notification preferences updated successfully:", data);
        setNLoading(false);
        handleClose();
      })
      .catch((error) => {
        setNLoading(false);
        handleClose();

        console.error("Error updating notification preferences:", error);
      });
  };

  const handleSvgClick = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch((error) => {
        if (error.name === "NotAllowedError") {
          console.log(
            "Playback was prevented by the browser. Please interact with the page first."
          );
        } else {
          console.error("Error playing audio:", error);
        }
      });
    }
    setIsPlaying(!isPlaying);
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const [dp, setDP] = useState("");
  const paragraphStyle = {
    color: selectedTheme?.textColor || "#5c5470",
  };

  const { slug, id } = useParams();


  const [selectedPlan, setSelectedPlan] = useState();
  const fetchMemorial = async () => {
    setMainLoader(true);

    try {
      const headers = await getAuthHeaders();
      const response = await fetch(`${backendUrl}/api/memorials/${id}`, { headers });
      if (response.ok) {
        const data = await parseJsonSafe(response);
        if (!data?.memorial) {
          setMainLoader(false);
          setMainError("Not Found");
          return;
        }
        const { theme, owner, planId } = data.memorial;
        setOwner(data.memorial.owner);
        setSelectedPlan(planId);
        setSelectedTheme(theme);
        setMemorial(data.memorial);
        setPendingTributeCount(data.pendingTributeCount || 0);
        setPendingTributesList(data.pendingTributes || []);
        setIsChecked(data.memorial.notification.post);
        setIsChecked1(data.memorial.notification.birthday);
        setIsChecked2(data.memorial.notification.passed);
        setEditData(data.memorial);
        setCurrentMusic(data.memorial.backgroundMusic[0]);
        if (data.memorial.backgroundMusic?.[0] && audioRef.current) {
          audioRef.current.src = data.memorial.backgroundMusic[0];
        }
        setMainLoader(false);
        const fragment = window.location.hash.substring(1);
        const fragmentSplit = fragment?.split("-");
        if (fragmentSplit.length > 1) {
          setCurrentTab(fragmentSplit[0]);
          setTimeout(() => {
            const targetElement = document.getElementById(fragmentSplit[1]);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: "smooth" });
            }
          }, 1000);
        }
        if (!initialTabApplied.current) {
          const tabParam = new URLSearchParams(window.location.search).get("tab");
          if (tabParam === "pendingTributes") {
            setCurrentTab("pendingTributes");
          } else if (planId === 0) {
            setCurrentTab("gallery");
          }
          initialTabApplied.current = true;
        }
      } else {
        console.error("Error fetching memorial:", response.statusText);
        setMainLoader(false);
        setMainError(response.statusText);
      }
    } catch (error) {
      console.error("Error fetching memorial:", error);
      setMainLoader(false);
      setMainError("Not Found");
    }
  };
  // Llamada inicial
/*useEffect(() => {
  fetchMemorial();
}, [fetchMemorial]);
*/
//Ejecuta fetch inicial del memorial y actualiza visitas
    useEffect(() => {
      updateVisitor();
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setDropdownOpen(false);
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, []);

// Fetch memorial for visitors; refetch when auth loads so owners see pending tributes
useEffect(() => {
  if (id) {
    fetchMemorial();
  }
}, [id]);

useEffect(() => {
  const email = user?.email || user?.meta?.email || auth.currentUser?.email;
  if (id && email) {
    fetchMemorial();
  }
}, [id, user?.email, user?.meta?.email]);
//  Establece el memorial ID en sessionStorage
  useEffect(() => {
    sessionStorage.setItem("memorialID", id);
  }, [id]);



/*nuevo para detección de pago, Verifica si venimos de un pago exitoso (?success=true)*/
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const paymentSuccess = query.get("success");

    if (paymentSuccess) {
      console.log("✅ Detected successful payment — refetching memorial...");
      fetchMemorial(); // 👈 tu función ya existente
    }
  }, []);

//Asigna el plan actual una vez cargado el memorial
useEffect(() => {
  if (memorial?.planId !== undefined) {
    setCurrentPlanId(memorial.planId);
  }
}, [memorial]);

// Redirect to clean canonical slug when URL uses legacy/encoded slug
useEffect(() => {
  if (!memorial?.slug || !slug || !id) return;
  const urlSlug = decodeURIComponent(slug);
  if (memorial.slug !== urlSlug) {
    navigate(`/profile/${memorial.slug}/${id}`, { replace: true });
  }
}, [memorial?.slug, slug, id, navigate]);

//setear el plan actual
useEffect(() => {
  if (availablePlans.length && typeof memorial?.planId === "number") {
    const matched = availablePlans.find(plan => plan.planName === memorial.planId);
    if (matched) {
      setCurrentPlan(matched);
    } else {
      console.warn("⚠️ No se encontró el plan correspondiente a planId:", memorial.planId);
    }
  }
}, [availablePlans, memorial]);

//Muestra en consola el estado de carga útil para debug
  useEffect(() => {
    console.log("currentUser", currentUser);
    console.log("memorial", memorial);
  }, [currentUser, memorial]);

//Calcular el hash secreto del memorial
  useEffect(() => {
    setSecretHash(SHA256(memorial?._id ?? "").toString());
  }, [memorial]);

//Comparar hash con parámetro de URL (para acceso con token)
  useEffect(() => {
    setAccessWithToken(secretHash === secret);
  }, [secret, secretHash]);

/*  useEffect(() => {
    if (audioRef.current && isPlaying) {
      audioRef.current.load();
      audioRef.current.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
    }
  }, [currentMusic]);  2003*/
  useEffect(() => {
    if (audioRef.current && isPlaying && currentMusic) {
      audioRef.current.src = currentMusic;
      audioRef.current.load();  // Asegura que el navegador recargue la fuente
      audioRef.current.play().catch((error) => {
        console.error("Error al reproducir el audio:", error);
      });
    }
  }, [currentMusic, isPlaying]);


  const isAdmin = () => {
    if (user && owner) {
      return (user.email || user.meta.email) == owner;
    }

    return false;
  };
  const updateVisitor = async () => {
    try {
      // Make a request to the backend endpoint based on the subMenu value
      let endpoint = `${backendUrl}/api/memorials/visitors/${id}`;
      const formData = new FormData();
      formData.append(
        "visitorName",
        user ? user.email || user.meta.email : "anonymous"
      );
      const data = {
        visitorName: user ? user.email || user.meta.email : "anonymous",
      };
      const response = await axios.put(endpoint, data, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("RESPONSE", response);
      // Handle the response, such as updating the component state with the updated memorial data
      setError(false);
    } catch (error) {
      console.error(error);

      setError(true);
    }
  };



  const UpdatePrivacy = async () => {
    setPrivacyLoading(true);
    try {
      let endpoint = `${backendUrl}/api/memorials/${id}`;
      const headers = await getAuthHeaders({ "Content-Type": "application/json" });
      const response = await axios.put(endpoint, memorial, { headers });
      setPrivacyLoading(false);
      fetchMemorial();
      setError(false);
    } catch (error) {
      console.error(error);
      setError(true);
    }
  };

  const handlePrivacyUpdate = async (isOnlyMe) => {
    const data = {
        publicVisibility: !isOnlyMe,
        privacy: { onlyme: isOnlyMe },
    };

    try {
        let endpoint = `${backendUrl}/api/memorials/${id}`;
        const headers = await getAuthHeaders({ "Content-Type": "application/json" });
        await axios.put(endpoint, data, { headers });

        setMemorial((prev) => ({
            ...prev,
            privacy: { ...prev.privacy, onlyme: isOnlyMe },
            publicVisibility: !isOnlyMe,
        }));

        setError(false);
    } catch (error) {
        console.error("Error updating privacy settings:", error);
        setError(true);
    }
};

const handleNotificationUpdate = async (type, value) => {
  const updatedNotification = {
    ...memorial.notification,
    [type]: value,
  };

  const data = {
    notification: updatedNotification,
  };

  try {
    let endpoint = `${backendUrl}/api/memorials/${id}`;
    const headers = await getAuthHeaders({ "Content-Type": "application/json" });
    await axios.put(endpoint, data, { headers });

    setMemorial((prev) => ({
      ...prev,
      notification: updatedNotification,
    }));

    setError(false);
  } catch (error) {
    console.error("Error updating notifications:", error);
    setError(true);
  }
};

const handleSlideshowUpdate = async (partial) => {
  try {
    const headers = await getAuthHeaders({ "Content-Type": "application/json" });
    await fetch(`${backendUrl}/api/memorials/${id}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(partial),
    });
    fetchMemorial();
  } catch (error) {
    console.error("Error updating slideshow:", error);
    toast.error("Could not update slideshow settings");
  }
};

  useEffect(() => {
  if (!memorial) return;

  const currentDate = new Date();

  const birthDate = memorial?.birthDate ? new Date(memorial.birthDate) : null;
  if (
    birthDate &&
    memorial?.privacy?.birthday &&
    birthDate.getMonth() === currentDate.getMonth() &&
    birthDate.getDate() === currentDate.getDate()
  ) {
    handlePrivacyUpdate(memorial.privacy.birthday);
  }

  const passedDate = memorial?.passedDate ? new Date(memorial.passedDate) : null;
  if (
    passedDate &&
    memorial?.privacy?.passed &&
    passedDate.getMonth() === currentDate.getMonth() &&
    passedDate.getDate() === currentDate.getDate()
  ) {
    handlePrivacyUpdate(memorial.privacy.passed);
  }
}, [memorial]);


  useEffect(() => {
  //  if (!user || !memorial) return;//2003
    const currentDate = new Date();
    if (user) {
      // Fetch the memorials owned by the user
      fetch(`${backendUrl}/api/memorials/user/${user.meta._id}/memorials`)
        .then((response) => response.json())
        .then((data) => {
          const { memorials } = data;
          // Iterate over the memorials
          memorials.forEach((memorial) => {
            const { birthday, passed, emailSent } = memorial.notification;

            // Verifica si el email ya fue enviado antes de intentar enviarlo de nuevo 2003
                //    if (emailSent) return;

            // Check if it's the birthday
            const birthDate = new Date(memorial.birthDate);
            if (
              !emailSent &&
              birthday &&
              birthDate.getMonth() === currentDate.getMonth() &&
              birthDate.getDate() === currentDate.getDate()
            ) {

              sendEmail("birthday", memorial);
            }

            // Check if it's the passed date
            const passedDate = new Date(memorial.passedDate);
            if (
              !emailSent &&
              passed &&
              passedDate.getMonth() === currentDate.getMonth() &&
              passedDate.getDate() === currentDate.getDate()
            ) {
              sendEmail("passed", memorial);
            }
          });
        })
        .catch((error) => {
          console.error("Error retrieving memorials:", error);
        });
    }
  }, [user]);//memorial, 2003

  const sendEmail = (event, memo) => {
    const from = "WillAlwaysLoveUTech@gmail.com";
    // Create an object with the email details
    const { firstName, _id, owner } = memo;

    const emailData =
      event == "birthday"
        ? {
            from: from,
            to: owner, // Change this to your backend endpoint
            text: `Today is ${firstName}'s Birthday. Wish hime here <a>https://willalwaysloveu.com/profile/${slug}/${_id}`,
            subject: `${firstName}'s Birthday`,
          }
        : event == "passed"
        ? {
            from: from,
            to: owner,// Change this to your backend endpoint
            text: `Today is ${firstName}'s death anniversary. Leave a tribute here <a>https://willalwaysloveu.com/profile/${slug}/${id}`,
            subject: `${firstName}'s Death anniversary`,
          }
        : {
            from: from,
            to: owner, // Change this to your backend endpoint
            text: `New Post created on the ${firstName}'s memorial  <a>https://willalwaysloveu.com/profile/${slug}/${id}`,
            subject: `New post on ${firstName}'s Memorial`,
          };

    // Make an HTTP POST request to your backend endpoint
    fetch(`${backendUrl}/api/memorials/${id}/sendEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);

        if (event != "post") {
          updateMemorialEmailSent(_id, true);
        }

        // Handle success or error response from the backend
      })
      .catch((error) => {
        console.error(error);
        // Handle error
      });
  };

  const updateMemorialEmailSent = (eid, emailSent) => {
    fetch(`${backendUrl}/api/memorials/${eid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ notification: { emailSent } }),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Memorial emailSent updated successfully");
        } else {
          console.log("Failed to update memorial emailSent");
        }
      })
      .catch((error) => {
        console.error("Error updating memorial emailSent:", error);
      });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleMemorialSubmit = async () => {
    try {
      setIsEditLoading(true);
      const headers = await getAuthHeaders({ "Content-Type": "application/json" });
      const response = await fetch(`${backendUrl}/api/memorials/${id}`, {
        method: "PUT",
        headers,
        body: JSON.stringify(editData),
      });

      if (response.ok) {
        const data = await response.json();

        setIsEditLoading(false);

        fetchMemorial();
      } else {
        console.error("Failed to add tribute:", response.statusText);
        // Handle the error case
      }
    } catch (error) {
      console.error("Error adding tribute:", error);
      // Handle the error case
    }
  };

  const handleStorySubmit = async (e) => {
    setLoading(true);
    const formData = new FormData();
    const timezoneName = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    formData.append("attachment", selectedFile);
    formData.append("title", storyTitle);
    formData.append("description", storyDesc);
    formData.append("author", user?.email || "guest");
    formData.append("date", Date.now());
    formData.append("timezone", timezoneName);
    if (!storyTitle || !storyDesc) {
      toast.error(`Please add ${!storyTitle ? "a title" : "description"}`);
      setLoading(false);
      return;
    }
    try {
      // Make a request to the backend endpoint to upload the display picture
      const response = await authFetch(
        `${backendUrl}/api/memorials/${id}/stories`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (response.ok) {
        // Display picture uploaded successfully, you can handle the response as needed
        console.log("Display picture uploaded successfully", response);
        setLoading(false);
        fetchMemorial();
        setCurrentTab("stories");
        setStoryDesc("");
        setStoryTitle("");
        setSelectedFile(undefined);
        if (memorial.notification.post) {
          sendEmail("post", memorial);
        }
      } else {
        // Error uploading display picture, handle the error
        console.error("Error uploading story:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading story:", error);
      setLoading(false);
    }
  };

  const handleStoryFile = async (e, value) => {
    const selectedFile = e.target.files ? e.target.files[0] : value;

    setSelectedFile(selectedFile);
    // Handle the selected file here
  };
  const handleLifeSubmit = async (e) => {
    setLoading(true);
    const formData = new FormData();
    const timezoneName = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    formData.append("attachment", selectedFile2);
    formData.append("title", storyTitle1);
    formData.append("description", storyDesc1);
    formData.append("author", user.email);
    formData.append("date", Date.now());
    formData.append("timezone", timezoneName);
    if (!storyTitle1 || !storyDesc1) {
      toast.error(
        `Please add ${
          !storyTitle1 ? "a title" : !storyDesc1 ? "description" : "an Image"
        }`
      );
      setLoading(false);
      return;
    }
    try {
      const response = await authFetch(`${backendUrl}/api/memorials/${id}/life`, {
        method: "PUT",
        body: formData,
      });

      if (response.ok) {
        setLoading(false);
        fetchMemorial();
        setStoryDesc1("");
        setSelectedFile2(undefined);
        setStoryTitle1("");
      } else {
        // Error uploading display picture, handle the error
        console.error("Error uploading story:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading story:", error);
      setLoading(false);
    }
  };

  const handleLifeFile = async (e) => {
    const selectedFile = e.target.files[0];
    setSelectedFile2(selectedFile);
  };
//para controlar las ediciones de life / about
const handleEditLife = (item) => {
  setEditingLifeId(item._id);
  setEditingLifeTitle(item.title);
  setEditingLifeDesc(item.description);
};
//para controlar las ediciones de life / about
const handleSaveEditLife = async (lifeId) => {
  try {
    const res = await authFetch(`${backendUrl}/api/memorials/${id}/life/${lifeId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title: editingLifeTitle,
        description: editingLifeDesc,
      }),
    });
    if (res.ok) {
      setEditingLifeId(null);
      fetchMemorial();
    } else {
      console.error("Error updating life story");
    }
  } catch (error) {
    console.error("Error updating life story:", error);
  }
};

  const handleFileInputChange = async (e, value) => {
    const selectedFile = e.target.files ? e.target.files[0] : value;
    setLoading(true);
    const formData = new FormData();
    formData.append(subMenu, selectedFile);

    try {
      // Make a request to the backend endpoint based on the subMenu value
      let endpoint = "";
      if (subMenu === "photo") {
        endpoint = `${backendUrl}/api/memorials/${id}/photos`;
      } else if (subMenu === "video") {
        endpoint = `${backendUrl}/api/memorials/${id}/videos`;
      } else if (subMenu === "audio") {
        endpoint = `${backendUrl}/api/memorials/${id}/audios`;
      }
      await axios.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...(await getAuthHeaders()),
        },
      });
      fetchMemorial();
      setLoading(false);
      setError(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setError(true);
    }
  };

  const handleCopyClick = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast("Link copied to clipboard");
      })
      .catch((error) => {
        console.error("Failed to copy text:", error);
      });
  };

  const addTribute = async () => {
    let userId = "";
    if (user || user !== null) {
      const { meta } = user;
      userId = meta?._id || "";
    } else {
      return setShowPrompt(true);
    }

    setIsTributeLoading(true);
    const tribute = {
      user: userId,
      timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
      date: new Date(Date.now()),
      description: tributeText,
    };
    try {
      const headers = await getAuthHeaders({ "Content-Type": "application/json" });
      const response = await fetch(
        `${backendUrl}/api/memorials/${id}/tributes`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(tribute),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setTributeText("");
        setIsTributeLoading(false);
        if (data.pending) {
          toast.info("Your tribute was submitted and is awaiting approval.");
        } else if (memorial.notification.post) {
          sendEmail("post", memorial);
        }
        fetchMemorial();
      } else {
        console.error("Failed to add tribute:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding tribute:", error);
    }
  };

  const relationships = [
    "Spouse",
    "Parent",
    "Sibling",
    "Child",
    "Friend",
    "Colleague",
    "Relative",
    "Partner",
  ];
  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, North",
    "Korea, South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];
  const memorialDestinations = [
    "Mountain",
    "Forest",
    "City",
    "Park",
    "Lake",
    "Island",
    "Countryside",
    "Desert",
    "Historical Site",
    "Landmark",
    "Garden",
    "Resort",
    "Waterfall",
    "Cave",
    "Village",
    "Museum",
    "Monument",
  ];

  const handleDisplayPictureChange = async (event) => {
    const selectedFile = event.target.files[0];
    setIsImageLoading(true);
    const formData = new FormData();
    formData.append("displayPicture", selectedFile);
    setDP(selectedFile);
    try {
      const response = await authFetch(
        `${backendUrl}/api/memorials/${id}/display-picture`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        console.log("Display picture uploaded successfully", response);
        setIsImageLoading(false);
        fetchMemorial();
      } else {
        // Error uploading display picture, handle the error
        console.error("Error uploading display picture:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading display picture:", error);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleCheckboxChange1 = () => {
    setIsChecked1(!isChecked1);
  };
  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2);
  };
  const handleCheckboxChange3 = () => {
    setIsChecked3(!isChecked3);
  };

  const handleOnlyMeChange = (e) => {
    const checked = e.target.checked;
    setMemorial((prevMemorial) => ({
      ...prevMemorial,
      publicVisibility: !checked,
      privacy: {
        ...prevMemorial.privacy,
        onlyme: checked,
      },
    }));
  };

  const handleBirthdayChange = (e) => {
    const checked = e.target.checked;
    setMemorial((prevMemorial) => ({
      ...prevMemorial,
      privacy: {
        ...prevMemorial.privacy,
        birthday: checked,
      },
    }));
  };

  const handlePassedChange = (e) => {
    const checked = e.target.checked;
    setMemorial((prevMemorial) => ({
      ...prevMemorial,
      privacy: {
        ...prevMemorial.privacy,
        passed: checked,
      },
    }));
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const musicInputRef = useRef(null);

  const handleMusicSelect = () => {
    musicInputRef.current.click();
  };

  /* 2103
  const handleMusicUpload = async (e) => {
    const selectedMusic = e.target.files[0];
    setMusicLoading(true);
    const formData = new FormData();
    formData.append("backgroundMusic", selectedMusic);
    try {
      let endpoint = `${backendUrl}/api/memorials/${id}`;
      await axios.put(endpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      fetchMemorial();
      setMusicLoading(false);
      setError(false);
    } catch (error) {
      console.error(error);
      setMusicLoading(false);
      setError(true);
    }
  };*/
  const handleMusicUpload = async (e) => {
    const selectedMusic = e.target.files[0];
    setMusicLoading(true);
    const formData = new FormData();
    formData.append("backgroundMusic", selectedMusic);
    try {
      let endpoint = `${backendUrl}/api/memorials/${id}`;
      const response = await axios.put(endpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data?.backgroundMusic) {
        setMemorial((prev) => ({
          ...prev,
          backgroundMusic: [...prev.backgroundMusic, response.data.backgroundMusic],
        }));
      }

      fetchMemorial();  // Para asegurar que los datos son correctos
      setMusicLoading(false);
      setError(false);
    } catch (error) {
      console.error(error);
      setMusicLoading(false);
      setError(true);
    }
  };

  /*
2103
  const handleMusicChange = async (e) => {
    setMusicLoading(true);
    try {
      let endpoint = `${backendUrl}/api/memorials/${id}`;
      await axios.put(endpoint, { backgroundMusic: e });
      setIsPlaying(true);
      setCurrentMusic(e);
      setMusicLoading(false);
      setError(false);
    } catch (error) {
      console.error(error);
      setMusicLoading(false);
      setError(true);
    }
  };*/
  const handleMusicChange = async (musicUrl) => {
  setMusicLoading(true);
  try {
    let endpoint = `${backendUrl}/api/memorials/${id}`;
    await axios.put(endpoint, { backgroundMusic: musicUrl });
    setCurrentMusic(musicUrl);
    setIsPlaying(true);

    if (audioRef.current) {
      audioRef.current.src = musicUrl;
      audioRef.current.load();  // Recarga la fuente de audio
      audioRef.current.play().catch((error) => {
        console.error("Error al reproducir el audio:", error);
      });
    }

    setMusicLoading(false);
    setError(false);
  } catch (error) {
    console.error(error);
    setMusicLoading(false);
    setError(true);
  }
};

  // Function to format the date string
  const formatDateString = (utcDate, timezone) => {
    if (timezone) {
      const localDate = moment.tz(utcDate, timezone);
      const day = localDate.format("DD");
      const month = localDate.format("MMMM");
      const year = localDate.format("YYYY");

      return `${month} ${day}, ${year}`;
    } else {
      const dateString = utcDate?.split("T")?.[0];
      const date = dateString?.split("-");
      const day = date[2];
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = monthNames[parseInt(date[1], 10) - 1];
      const year = date[0];
      return `${month} ${day}, ${year}`;
    }
  };

  const galleryMenu =
    selectedTheme && selectedPlan === 0
      ? {
          photo: (
            <>
              {memorial?.gallery.videos.length < 5 && (
                <>
                  <p className="section-text">Add a Photo</p>
                  <UploadBox
                    device={true}
                    // facebook={true}
                    handleFileInputChange={handleFileInputChange}
                  />
                </>
              )}
              <div className="gallery">
                {memorial?.gallery.videos.length == 0 && (
                  <div className="gallery-item"></div>
                )}
                {!loading ? (
                  memorial?.gallery.photos.map((vid) => (
                    <div className="gallery-item">
                      <img src={vid} alt="" />
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ProgressBar
                      height="80"
                      width="80"
                      ariaLabel="progress-bar-loading"
                      wrapperStyle={{}}
                      wrapperClass="progress-bar-wrapper"
                      borderColor={selectedTheme?.textColor || "#5c5470"}
                      barColor={selectedTheme?.textColor || "#5c5470"}
                    />
                    <p
                      style={{
                        color: selectedTheme?.textColor || "#5c5470",
                        fontSize: "10px",
                      }}
                    >
                      Uploading ...
                    </p>
                  </div>
                )}
              </div>
            </>
          ),
        }
      : {
          photo: (
  <>
    <p className="section-text">Add a Photo</p>
    <UploadBox
      device={true}
      handleFileInputChange={handleFileInputChange}
    />
    <div className="gallery">
      {memorial?.gallery?.videos?.length === 0 && (
        <div className="gallery-item"></div>
      )}
      {!loading ? (
        memorial?.gallery?.photos?.map((vid, index) => (
          <div key={index} className="gallery-item">
            <img src={vid} alt={`Gallery ${index + 1}`} />
          </div>
        ))
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperClass="progress-bar-wrapper"
            borderColor={selectedTheme?.textColor || "#5c5470"}
            barColor={selectedTheme?.textColor || "#5c5470"}
          />
          <p style={{ color: selectedTheme?.textColor || "#5c5470", fontSize: "10px" }}>
            Uploading ...
          </p>
        </div>
      )}
    </div>
  </>
),
          video: (
  <>
    <p className="section-text">Add a Video</p>
    <UploadBox
      device={true}
      handleFileInputChange={handleFileInputChange}
    />
    <div className="gallery">
      {memorial?.gallery?.videos?.length === 0 && (
        <div className="gallery-item"></div>
      )}
      {!loading ? (
        memorial?.gallery?.videos?.map((vid, index) => (
          <div key={index} className="gallery-item">
            <video src={vid} controls />
          </div>
        ))
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperClass="progress-bar-wrapper"
            borderColor={selectedTheme?.textColor || "#5c5470"}
            barColor={selectedTheme?.textColor || "#5c5470"}
          />
          <p style={{ color: selectedTheme?.textColor || "#5c5470", fontSize: "10px" }}>
            Uploading ...
          </p>
        </div>
      )}
    </div>
  </>
),

          audio: (
  <>
    <p className="section-text">Add an Audio</p>
    <UploadBox
      device={true}
      handleFileInputChange={handleFileInputChange}
    />
    <div className="gallery">
      {memorial?.gallery?.audios?.length === 0 && (
        <div className="gallery-item"></div>
      )}
      {!loading ? (
        memorial?.gallery?.audios?.map((vid, index) => (
          <div key={index} className="gallery-item">
            <audio src={vid} controls={true} />
          </div>
        ))
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperClass="progress-bar-wrapper"
            borderColor={selectedTheme?.textColor || "#5c5470"}
            barColor={selectedTheme?.textColor || "#5c5470"}
          />
          <p style={{ color: selectedTheme?.textColor || "#5c5470", fontSize: "10px" }}>
            Uploading ...
          </p>
        </div>
      )}
    </div>
  </>
),

        };

/*para el tab my plan*/

useEffect(() => {
  const fetchPlan = async () => {
    try {
      const user = await auth.currentUser;
      if (!user) return;

      const token = await user.getIdToken(); // 🔐 obtiene el token
      const base = backendUrl || "http://localhost:5000";
      const response = await fetch(`${base.replace(/\/$/, "")}/api/user/plan`, {
        headers: {
          Authorization: `Bearer ${token}`, // 👈 lo manda en header
        },
      });

      if (!response.ok) throw new Error("Failed to fetch plan");
      const data = await response.json();
      setCurrentPlan(data.currentPlan); // ahora será un objeto completo con name, description, stripePriceId, etc.
      if (data.shippingAddress) {
        setShippingAddress(data.shippingAddress);
      }
    } catch (error) {
      console.error("Error fetching user plan:", error);
    }
  };

  fetchPlan();
}, []);

//campo direccion en my plan
const handleSaveAddress = async () => {
  try {
    const user = await auth.currentUser;
    const token = await user.getIdToken();
    const base = backendUrl || "http://localhost:5000";
    const res = await fetch(`${base.replace(/\/$/, "")}/api/user/shipping-address`, {
      method: "POST", 
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ address: shippingAddress }),
    });
    const text = await res.text();
    console.log("🧾 STATUS:", res.status);
    console.log("📨 RESPUESTA:", text);
    if (!res.ok) throw new Error();
    alert("Dirección guardada ✅");
  } catch {
    alert("Error guardando la dirección.");
  }
};


/*fin tab my plan*/

  const manageVisitorPanel = (
    <Card Width="90%">
      <p className="manage-title2">Visitors</p>
      <p style={paragraphStyle} className="views-top-text">
        {memorial?.visitors?.length || 0} Views
      </p>
      <div className="manage-btn-section">
        <p style={{ color: selectedTheme?.textColor }} className="visited-btn">
          Visited {`(${memorial?.visitors?.length || 0})`}
        </p>
      </div>
      <div className="manage-box">
        {memorial?.visitors?.map((item, vIdx) => (
          <div
            key={vIdx}
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "center",
              alignItems: "center",
              color: selectedTheme?.textColor,
            }}
          >
            <Avatar /> {item}
          </div>
        ))}
      </div>
    </Card>
  );

  const settingsPanels = memorial
    ? {
        privacy: (
          <MemorialPrivacySettings
            memorial={memorial}
            onPrivacyUpdate={handlePrivacyUpdate}
            onNotificationUpdate={handleNotificationUpdate}
            onRefresh={fetchMemorial}
          />
        ),
        pendingTributes: (
          <MemorialPendingTributes
            memorial={memorial}
            pendingTributes={pendingTributesList}
            selectedTheme={selectedTheme}
            paragraphStyle={paragraphStyle}
            backendUrl={backendUrl}
            memorialId={id}
            onRefresh={fetchMemorial}
          />
        ),
        transfer: (
          <MemorialTransferSettings
            memorial={memorial}
            selectedTheme={selectedTheme}
            backendUrl={backendUrl}
            memorialId={id}
          />
        ),
        manageVisitor: manageVisitorPanel,
      }
    : null;

  const cardObject = selectedTheme && {
    about: (
      <>
        <Dialog
          open={showPrompt}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setShowPrompt(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <span style={{ margin: "auto", fontSize: "25px" }}></span>Adding a
            Tribute
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {/* color selectedTheme?.textColor */}
              <span style={{ fontSize: "20px" }}>
                <Link to="/signup">
                  <span
                    style={{
                      color: selectedTheme?.textColor,
                      textDecoration: "underline",
                    }}
                  >
                    Sign up
                  </span>{" "}
                </Link>
                or{" "}
                <Link to="/login">
                  <span
                    style={{
                      color: selectedTheme?.textColor,
                      textDecoration: "underline",
                    }}
                  >
                    log in{" "}
                  </span>
                </Link>
                first for add a heartfelt tribute and share your cherished
                memories.
              </span>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Card Width="75vw">
          <div className="card-header">
            <Button
              disabled={!isAdmin()}
              bgColor={selectedTheme?.textColor || "#5c5470"}
              onClick={() => setCurrentTab("form")}
              icon={
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.8299 4.0859L14.7474 0.992231C14.3451 0.61297 13.8179 0.395356 13.2661 0.380783C12.7143 0.366211 12.1765 0.555697 11.7549 0.913196L1.62974 11.0749C1.2661 11.4429 1.03968 11.9253 0.988484 12.441L0.504728 17.1493C0.489573 17.3147 0.510955 17.4814 0.567348 17.6375C0.623741 17.7936 0.713758 17.9353 0.830982 18.0526C0.936103 18.1572 1.06077 18.24 1.19784 18.2962C1.33491 18.3524 1.48168 18.3808 1.62974 18.38H1.73099L6.42229 17.9509C6.9362 17.8996 7.41684 17.6723 7.78356 17.3074L17.9087 7.14569C18.3017 6.72902 18.514 6.173 18.4993 5.59946C18.4845 5.02592 18.2438 4.48165 17.8299 4.0859ZM6.21979 15.6928L2.84475 16.0089L3.14851 12.6217L9.50483 6.32146L12.5424 9.36997L6.21979 15.6928ZM14.0049 7.85701L10.9898 4.83109L13.1836 2.57294L16.2549 5.65531L14.0049 7.85701Z"
                    fill="white"
                  />
                </svg>
              }
              text="Edit"
              showDropdown={true}
            />
          </div>
          <div className="card-quote">
            <div className="quote">
              {/*<div className="quote-content">
                <div style={{ margin: "15px" }}>
                  <svg
                    width="46"
                    height="37"
                    viewBox="0 0 46 37"
                    fill={selectedTheme?.textColor || "#5c5470"}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.34173 5.59993C7.51251 2.16247 12.3105 0.420006 18.6001 0.420006H20.8601V6.79095L19.043 7.15481C15.9468 7.77405 13.793 8.99218 12.6405 10.7798C12.039 11.7429 11.698 12.8456 11.6506 13.98H18.6001C19.1995 13.98 19.7743 14.2181 20.1981 14.6419C20.622 15.0658 20.8601 15.6406 20.8601 16.24V32.06C20.8601 34.5528 18.8328 36.58 16.3401 36.58H2.78007C2.18068 36.58 1.60584 36.3419 1.18201 35.9181C0.758176 35.4942 0.52007 34.9194 0.52007 34.32V23.02L0.52685 16.4231C0.50651 16.1722 0.0771099 10.2284 4.34173 5.59993ZM41.2001 36.58H27.6401C27.0407 36.58 26.4658 36.3419 26.042 35.9181C25.6182 35.4942 25.3801 34.9194 25.3801 34.32V23.02L25.3869 16.4231C25.3665 16.1722 24.9371 10.2284 29.2017 5.59993C32.3725 2.16247 37.1705 0.420006 43.4601 0.420006H45.7201V6.79095L43.903 7.15481C40.8068 7.77405 38.6531 8.99218 37.5005 10.7798C36.8991 11.7429 36.558 12.8456 36.5106 13.98H43.4601C44.0595 13.98 44.6343 14.2181 45.0581 14.6419C45.482 15.0658 45.7201 15.6406 45.7201 16.24V32.06C45.7201 34.5528 43.6929 36.58 41.2001 36.58Z"
                      fill={selectedTheme?.textColor || "#5c5470"}
                    />
                  </svg>
                </div>

                <p style={paragraphStyle} className="quote-main-text">
                  Let the memory of {memorial?.firstName} be with us forever.
                </p>
              </div>*/}
              <ul className="dot-list">
                {(memorial?.birthDate || memorial?.country) && (
                  <li style={paragraphStyle}>
                    Born{" "}
                    {memorial?.birthDate && (
                      <>
                        on {formatDateString(memorial?.birthDate)}{" "}
                        {/* {new Date(memorial?.birthDate).toLocaleDateString(
                          "en-US",
                          {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          }
                        )} */}
                      </>
                    )}
                    {memorial?.country && <> in {memorial?.country}</>}
                  </li>
                )}
                {memorial?.passedDate || memorial?.deathCountry ? (
                  <li style={paragraphStyle}>
                    Passed away{" "}
                    {memorial?.passedDate && (
                      <>
                        on {formatDateString(memorial?.passedDate)}{" "}
                        {/* {new Date(memorial?.passedDate).toLocaleDateString(
                          "en-US",
                          {
                            month: "long",
                            day: "numeric",
                            year: "numeric",
                          }
                        )}{" "} */}
                      </>
                    )}
                    {memorial?.deathCountry && <>in {memorial?.deathCountry}</>}
                  </li>
                ) : null}
              </ul>
            </div>
            <p style={paragraphStyle} className="section-text">
              Tribute
            </p>
          </div>
          {memorial?.about?.tributes?.length === 0 && (
            <p>No tributes yet.</p>
          )}
          {memorial &&
            memorial.about.tributes
              .filter((t) => (t.status || "approved") === "approved")
              .map((tribute, idx) => (
              <Card Width="65vw">
                <div id={`${idx}`} className="content-card">
                  <div className="picture">
                    {/* Your picture component or image goes here */}
                    <img src={tribute.user?.displayPicture || dummy} />
                  </div>
                  <div className="text">
                    <p style={paragraphStyle} className="name-text">
                      {tribute?.user?.name || "Guest"}
                    </p>
                    <p style={paragraphStyle} className="date-text">
                      {console.log("hello", tribute.date)}
                      {/* {tribute.date} */}
                      {/* {new Date(tribute.date).toLocaleString()} */}
                      {formatDateString(tribute.date, tribute?.timezone)}
                    </p>
                    {/*<p style={paragraphStyle} className="card-description">
                      {tribute.description}
                    </p>*/}
                     {/*edición de comentario en tributes*/}
                     {console.log("currentUser:", currentUser, "tribute.user:", tribute.user)}
                      {currentUser?._id === tribute.user?._id ? (
                      isEditingId === tribute._id ? (
                        <>
                          <textarea
                            value={editedDescription}
                            onChange={(e) => setEditedDescription(e.target.value)}
                            rows={3}
                            className="multiline-input"
                          />
                          <div className="btn-section" style={{ marginTop: "10px" }}>
                            <Button
                              text="Guardar"
                              bgColor={selectedTheme?.textColor || "#5c5470"}
                              onClick={() => handleSaveEdit(tribute._id)}
                            />
                            <Button
                              text="Cancelar"
                              bgColor="#ccc"
                              onClick={() => setIsEditingId(null)}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p style={paragraphStyle} className="card-description">
                            {tribute.description}
                          </p>
                          <Button
                            text="Editar"
                            bgColor={selectedTheme?.textColor || "#5c5470"}
                            onClick={() => {
                              setIsEditingId(tribute._id);
                              setEditedDescription(tribute.description);
                            }}
                          />
                        </>
                      )
                    ) : (
                      <p style={paragraphStyle} className="card-description">
                        {tribute.description}
                      </p>
                    )}
                  {/*fin edición de comentario en tributes*/}
                  </div>
                </div>
              </Card>
            ))}

          <p style={paragraphStyle} className="section-text">
            Leave a Tribute
          </p>
          <div className="input-div">
            <textarea
              onChange={(e) => setTributeText(e.target.value)}
              style={{
                border: `1px solid ${selectedTheme?.textColor || "#5c5470"}`,
              }}
              value={tributeText}
              className="multiline-input"
              rows={4}
            ></textarea>

            <div style={{ marginTop: "20px" }} className="btn-section">
              <Button
                isLoading={isTributeLoading}
                onClick={addTribute}
                bgColor={selectedTheme?.textColor || "#5c5470"}
                text="Publish"
              />
            </div>
          </div>
        </Card>
      </>
    ),
    form: (
      <Card>
        <Card.Header>
          <p className="title">About your loved one:</p>
        </Card.Header>
        <Card.Content>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="firstName">First Name:</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={editData.firstName}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
            <div className="form-field">
              <label htmlFor="lastName">Last Name:</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={editData?.lastName}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="relationship">Relationship:</label>
              <select
                className="custom-arrow"
                id="relationship"
                name="relationship"
                value={editData?.relationship}
                onChange={(e) => handleEditChange(e)}
              >
                <option value="">Select</option>
                {relationships.map((relationship) => (
                  <option value={relationship} key={relationship}>
                    {relationship}
                  </option>
                ))}
                {/* Options for relationship selection */}
              </select>
            </div>
            <div className="form-field">
              <label htmlFor="radio-id">Gender:</label>
              <div id="radio-id" className="radio-group">
                {/* Radio buttons for gender selection */}
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    checked={editData?.gender === "male"}
                    onChange={(e) => handleEditChange(e)}
                  />
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    checked={editData?.gender === "female"}
                    onChange={(e) => handleEditChange(e)}
                  />
                  Female
                </label>
              </div>
            </div>
          </div>
          <div className="form-row">
            {/*<div className="form-field">
              <label htmlFor="memorialDesignation">Memorial Designation:</label>
              <select
                id="memorialDesignation"
                name="memorialDesignation"
                value={editData?.memorialDestination}
                onChange={(e) => handleEditChange(e)}
              >
                <option value="">Select</option>
                {memorialDestinations.map((relationship) => (
                  <option value={relationship} key={relationship}>
                    {relationship}
                  </option>
                ))}
                
                <option>Select</option>
              </select>
            </div>*/}
            {/*<div className="form-field">
              <label htmlFor="country">Country:</label>
              <select
                id="country"
                name="country"
                value={editData?.country}
                onChange={(e) => handleEditChange(e)}
              >
                <option value="">Select</option>
                {countries.map((relationship) => (
                  <option value={relationship} key={relationship}>
                    {relationship}
                  </option>
                ))}
                 
              </select>
            </div>*/}
          </div>
          {/*<div className="form-row">
            <div className="form-field">
              <label htmlFor="webAddress">Web address:</label>
              <input
                type="text"
                id="webAddress"
                name="webAddress"
                value={editData?.webAddress}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
          </div>*/}
        </Card.Content>

        <Card.Header>
          <p className="title">Birth:</p>
        </Card.Header>
        <Card.Content>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="birthDate">Birth Date:</label>
              <input
                type="date"
                id="birthDate"
                name="birthDate"
                value={editData?.birthDate ? editData.birthDate.split("T")[0] : ""}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
            {/*<div className="form-field">
              <label htmlFor="birthPlace">Birth Place:</label>
              <input
                type="text"
                id="birthPlace"
                name="birthPlace"
                value={editData?.birthPlace}
                onChange={(e) => handleEditChange(e)}
              />
            </div>*/}
          </div>
        </Card.Content>

        <Card.Header>
          <p className="title">Passed:</p>
        </Card.Header>
        <Card.Content>
          <div className="form-row">
            <div className="form-field">
              <label htmlFor="passedDate">Passed Date:</label>
              <input
                type="date"
                id="passedDate"
                name="passedDate"
                value={editData?.passedDate ? editData.passedDate.split("T")[0] : ""}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
            {/*<div className="form-field">
              <label htmlFor="deathPlace">Death Place:</label>
              <input
                type="text"
                id="deathPlace"
                name="deathPlace"
                value={editData?.deathPlace}
                onChange={(e) => handleEditChange(e)}
              />
            </div>*/}
          </div>
          {/*<div className="form-row">
            <div className="form-field">
              <label htmlFor="deathCountry">Death Country:</label>
              <input
                type="text"
                id="deathCountry"
                name="deathCountry"
                value={editData?.deathCountry}
                onChange={(e) => handleEditChange(e)}
              />
            </div>
          </div>*/}
        </Card.Content>

        <div className="right">
          <button className="cancel-btn" onClick={() => setCurrentTab("about")}>
            Cancel
          </button>
          <Button
            onClick={handleMemorialSubmit}
            bgColor={selectedTheme?.textColor || "#5c5470"}
            isLoading={isEditLoading}
            className="save-btn"
            text="Save"
          />
        </div>
      </Card>
    ),
    backgroundMusic: (
      <Card>
        <Card.Header>
          <p className="title">Background playlist:</p>
        </Card.Header>
        <Card.Content>
          <div className="form-row">
            <div className="form-field">
              <label
                style={{
                  marginBottom: "20px",
                }}
              >
                {currentMusic
                  ? currentMusic
                      .split("/")
                      .pop()
                      .replace(".mp3", "")
                      .replaceAll("-", " ")
                      .replaceAll("%20", " ")
                  : "No background Music"}
              </label>
              {
              /*  console.log(
                "memorial?.backgroundMusic",
                memorial?.backgroundMusic
              )*/
            }
              <select
                className="custom-arrow"
                // defaultValue={memorial?.backgroundMusic[1]}
                value={currentMusic}
                onChange={(e) => handleMusicChange(e.target.value)}
              >
                <option value="">Select</option>
                {memorial?.backgroundMusic.map((music) => {
                  const musicName = music.split("/").pop().replace(".mp3", "");
                  return (
                    <option value={music} key={music}>
                      {musicName}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div>
            <input
              ref={musicInputRef}
              type="file"
              accept="audio/*"
              onChange={handleMusicUpload}
              style={{ display: "none" }}
            />
            <Button
              isLoading={loadingMusic}
              onClick={handleMusicSelect}
              bgColor={selectedTheme?.textColor || "#5c5470"}
              icon={
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.125 17C1.54063 17 1.04019 16.7917 0.623689 16.3752C0.207189 15.9587 -0.000706529 15.4587 1.80391e-06 14.875V11.6875H2.125V14.875H14.875V11.6875H17V14.875C17 15.4594 16.7917 15.9598 16.3753 16.3763C15.9588 16.7928 15.4587 17.0007 14.875 17H2.125ZM7.4375 12.75V4.09062L4.675 6.85312L3.1875 5.3125L8.5 0L13.8125 5.3125L12.325 6.85312L9.5625 4.09062V12.75H7.4375Z"
                    fill="white"
                  />
                </svg>
              }
              className="save-btn"
              text="Add your own music"
            />
          </div>
        </Card.Content>

        <div className=""></div>
      </Card>
    ),
    phrase: (
      <Card>
        <div className="card-header">
          <div className="intro-section-new">
            <p className="section-text">Personal phrase</p>

            <ReactQuill
              style={{ border: "none", color: "black" }}
              className="react-quill"
              theme="snow"
              value={value}
              onChange={setValue}
            />
          </div>
        </div>
        <Card>
          <div className="content-card">
            <div className="picture">
              {/* Your picture component or image goes here */}
              <img src={Profilepicture} />
            </div>
            <div className="text">
              <p className="name-text">Sayed Adnan</p>
              <p className="date-text">May 24</p>
              <p className="card-description">
                I too have fond memories of cycling the Marble Mountain loop
                with Barb and other friends; she was such a smooth cyclist! I
                was so impressed that she biked in former Soviet Union countries
                (Slovenia and the Czech Republic, I think) all by herself, as
                well as in many countries in Europe with friends. She was also
                very willing to help. At Obsidian Summer Camp, she was often a
                lead person on various food related tasks. And she was very
                proud of her family and their accomplishments.
              </p>
              <div className="share-button">
                <a>
                  <Button
                    icon={
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 21.12C19.6569 21.12 21 19.7768 21 18.12C21 16.4631 19.6569 15.12 18 15.12C16.3431 15.12 15 16.4631 15 18.12C15 19.7768 16.3431 21.12 18 21.12Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 13.62L15 16.62"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 15.12C7.65685 15.12 9 13.7768 9 12.12C9 10.4631 7.65685 9.12 6 9.12C4.34315 9.12 3 10.4631 3 12.12C3 13.7768 4.34315 15.12 6 15.12Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15 7.62L9 10.62"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18 9.12C19.6569 9.12 21 7.77685 21 6.12C21 4.46314 19.6569 3.12 18 3.12C16.3431 3.12 15 4.46314 15 6.12C15 7.77685 16.3431 9.12 18 9.12Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    }
                    text="Share"
                  />
                </a>
              </div>
            </div>
          </div>
        </Card>

        <p className="section-text">Leave a Tribute</p>
        <div className="input-div">
          <textarea className="multiline-input" rows={4}></textarea>
          <div className="input-foot">
            <div className="foot-text-1">by Adnan</div>
            <div className="foot-text-2">
              Change
              <svg
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 1.12L5 5.12L1 1.12"
                  stroke="#5C5470"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="btn-section">
            <Button text="Publish" />
          </div>
        </div>
      </Card>
    ),
    life: (
      <Card Width="90vw">
        <div className="card-header">
          {isAdmin() && (
            <div className="intro-section-new">
              <p className="card-description-life">
                You can create a detailed account of your loved one's journey through life. Share their experiences, milestones, and key moments that reflect who they were. Take a walk through their childhood, adolescence, and adult years, remembering the dates and events that were significant to them. Collaborate with family members to help build a comprehensive, heartfelt story that brings their life and legacy to life for others to appreciate.
              </p>
              <p className="section-text">Add a life story chapter</p>
              <input
                value={storyTitle1}
                onChange={(e) => setStoryTitle1(e.target.value)}
                placeholder="Title"
                className="title-input"
              />
              <ReactQuill
                style={{ border: "none", color: "black" }}
                className="react-quill-2"
                theme="snow"
                value={storyDesc1}
                onChange={setStoryDesc1}
              />
            </div>
          )}
        </div>

       {/* <p className="section-text">Life Chapters</p>*/}
        {isAdmin() && (
          <div className="input-div">
           {/*  <UploadBox
              handleFileInputChange={handleLifeFile}
              // facebook={true}
              device={true}
            />*/}
            <div style={{ marginBottom: "10px" }} className="input-foot">
              <div className="foot-text-1"> </div>
              <div className="foot-text-2"></div>
            </div>
            <div className="btn-section">
              <Button
                onClick={handleLifeSubmit}
                bgColor={selectedTheme?.textColor}
                isLoading={loading}
                text="Publish"
              />
            </div>
          </div>
        )}

        {memorial?.life?.map((item) => {
          const isEditing = editingLifeId === item._id;

          return (
            <Card Width="80%" key={item._id}>
              {item.attachments?.[0] && (
                <div className="story-img">
                  <img src={item.attachments[0]} />
                </div>
              )}

              {isEditing ? (
                <div className="story-edit-form">
                  <input
                    className="title-input"
                    value={editingLifeTitle}
                    onChange={(e) => setEditingLifeTitle(e.target.value)}
                    placeholder="Title"
                  />
                  <ReactQuill
                    style={{ border: "none", color: "black" }}
                    className="react-quill-2"
                    theme="snow"
                    value={editingLifeDesc}
                    onChange={setEditingLifeDesc}
                  />
                  <div className="btn-section" style={{ marginTop: "10px" }}>
                    <Button
                      text="Save"
                      bgColor={selectedTheme?.textColor}
                      onClick={() => handleSaveEditLife(item._id)}
                    />
                    <Button
                      text="Cancel"
                      bgColor="#888"
                      onClick={() => setEditingLifeId(null)}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="story-title">
                    <p className="title1">{item.title}</p>
                    <p className="story-date">
                      {formatDateString(item?.date, item?.timezone)}
                      {item.author ? ` by ${item.author}` : ""}
                    </p>
                  </div>
                  <p className="story-para">{parse(item.description)}</p>
                  <div className="story-btn">
                    {/* <Button bgColor={selectedTheme?.textColor} text="Share" /> */}
                    {isAdmin() && (
                      <Button
                        text="Edit"
                        bgColor={selectedTheme?.textColor}
                        onClick={() => handleEditLife(item)}
                      />
                    )}
                  </div>
                </>
              )}
            </Card>
          );
        })}
      </Card>
    ),
    createStory: (
      <Card>
        <div className="card-header">
          <div className="intro-section-new">
            <p className="card-description-life">
              In this section, you can create a chapter by chapter biography of
              your loved one's life. You can help others to get to know more
              intimately and for a moment experience the world through his eyes.
              Describe memorable dates and events from his childhood, youth, and
              adult life. Collaborate with other members of your family to build
              a complete and rich life story
            </p>
            <p className="section-text">Add a story </p>
            <input
              value={storyTitle}
              onChange={(e) => setStoryTitle(e.target.value)}
              placeholder="Title"
              className="title-input"
            />
            <ReactQuill
              style={{ border: "none", color: "black" }}
              className="react-quill-2"
              theme="snow"
              value={storyDesc}
              onChange={setStoryDesc}
            />
          </div>
        </div>

        <p className="section-text">Leave a Tribute</p>
        <div className="input-div">
          <UploadBox
            handleFileInputChange={handleStoryFile}
            // facebook={true}
            device={true}
          />
          <div style={{ marginBottom: "10px" }} className="input-foot">
            <div className="foot-text-1"> </div>
            <div className="foot-text-2"></div>
          </div>

          <div className="btn-section">
            <Button
              onClick={handleStorySubmit}
              bgColor={selectedTheme?.textColor}
              isLoading={loading}
              text="Publish"
            />
          </div>
        </div>
      </Card>
    ),
    gallery: (
      <MemorialGallery
        memorial={memorial}
        selectedPlan={selectedPlan}
        selectedTheme={selectedTheme}
        subMenu={subMenu}
        setSubMenu={setSubMenu}
        loading={loading}
        handleFileInputChange={handleFileInputChange}
        onSlideshowUpdate={handleSlideshowUpdate}
        isAdmin={isAdmin()}
      />
    ),
    privacy: settingsPanels?.privacy,
    pendingTributes: settingsPanels?.pendingTributes,
    transfer: settingsPanels?.transfer,
    manageVisitor: settingsPanels?.manageVisitor,
    stories: (
      <div className="story-container">
        <Card Width="80%">
          <div className="story-header">
            <p style={{ color: selectedTheme?.textColor }}>
              Share a special moment from {memorial?.firstName}'s life
            </p>
            <Button
              onClick={() => setCurrentTab("createStory")}
              bgColor={selectedTheme?.textColor}
              text="Write A Story"
            />
          </div>
        </Card>
        {memorial?.story.map((item, idx) => {
          const stringWithoutPTag = item.description.replace(/<\/?p>/g, "");
          return (
            <Card Width="80%">
              <div id={`${idx}`} className="story-img">
                <img
                  style={{ borderRadius: "10px" }}
                  src={item.attachments[0]}
                />
              </div>
              <div className="story-title">
                <p className="title1">{item.title}</p>
                <p className="story-date">
                  {" "}
                  {/* {new Date(item?.date).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}{" "} */}
                  {formatDateString(item?.date, item?.timezone)} by{" "}
                  {item.author}
                </p>
              </div>
              <p className="story-para">{parse(item.description)}</p>
            </Card>
          );
        })}
      </div>
    ),
  };
  const fileInputRef = React.useRef(null);

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };
   const [isPrivate, setIsPrivate] = useState(false);

  const handleShareModalOpen = () => {
    setOpenShareModal(true);
  };
  const handleShareModalClose = () => {
    setOpenShareModal(false);
  };

// Guard return URL so login brings user back to this memorial
useEffect(() => {
  if (!user && id) {
    saveReturnUrl(window.location.pathname + window.location.search);
  }
}, [user, id, slug]);

const settingsMenuItems = [
  ...(pendingTributeCount > 0
    ? [{ ref: "pendingTributes", title: "Pending tributes", badge: pendingTributeCount, highlight: true }]
    : []),
  { ref: "manageVisitor", title: "Visitors" },
  { ref: "privacy", title: "Privacy settings" },
  ...(pendingTributeCount === 0
    ? [{ ref: "pendingTributes", title: "Pending tributes" }]
    : []),
  { ref: "transfer", title: "Transfer ownership" },
  { ref: "themes", title: "Themes" },
  { ref: "backgroundMusic", title: "Background music" },
];
  const memorialShareUrl = memorial ? getMemorialShareUrl(memorial, id) : "";
  const showHeroSlideshow =
    memorial?.gallerySlideshow?.enabled &&
    (memorial?.gallery?.photos?.length || 0) >= 2 &&
    (currentTab === "about" || currentTab === "gallery");

  return (
    <div style={{ color: "red" }} className="theme-container">
      {memorial &&
      (isAdmin() || memorial.publicVisibility || accessWithToken) ? (
        <>
          <div className="cover-picture">
            <img src={selectedTheme?.backgroundImg} alt="" />
          </div>
          <div className="profile-picture">
            {isAdmin() && (
            <div
              className="profile-editicon"
              style={{
                borderColor: `${selectedTheme?.textColor || "#5c5470"}`,
              }}
            >
              <img src={editIcon} onClick={handleAvatarClick} alt="img" />
            </div>
            )}
            {isImgLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "80px",
                }}
              >
                <ProgressBar
                  height="80"
                  width="80"
                  ariaLabel="progress-bar-loading"
                  wrapperStyle={{}}
                  wrapperClass="progress-bar-wrapper"
                  borderColor={selectedTheme?.textColor || "#5c5470"}
                  barColor={selectedTheme?.textColor || "#5c5470"}
                />
              </div>
            ) : (
              <>
                <img src={memorial?.displayPicture || dummy} />
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  disabled={!isAdmin()}
                  onChange={handleDisplayPictureChange}
                  style={{ display: "none" }}
                />
              </>
            )}
          </div>
          <div className="name-container">
            <div style={{ marginTop: "10px" }} className="name-section">
              <p
                style={{
                  color: `${selectedTheme?.textColor || "#5c5470"}`,
                  marginTop: "22px",
                }}
              >{`${memorial?.firstName} ${memorial?.lastName}`}</p>
              {!isPlaying && selectedPlan !== 0 ? (
                <svg
                  onClick={handleSvgClick}
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  width="28"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                    fill={selectedTheme?.textColor}
                  />
                </svg>
              ) : selectedPlan !== 0 ? (
                <svg
                  onClick={handleSvgClick}
                  cursor="pointer"
                  width="26"
                  height="24"
                  viewBox="0 0 26 24"
                  fill={selectedTheme?.textColor}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.031 0.0520186C11.71 0.0530186 11.355 0.197019 11.031 0.520019L5.312 6.98902H1C0.449 6.98902 0 7.43802 0 7.98902V15.989C0 16.54 0.449 16.989 1 16.989H5.313L11 23.427C12 24.427 13 23.915 13 22.552V1.26902C13 0.478019 12.567 0.0470186 12.031 0.0500186V0.0520186ZM19.281 2.05202C19.0683 2.08912 18.8734 2.19405 18.7253 2.35114C18.5772 2.50822 18.4839 2.70901 18.4593 2.92351C18.4348 3.138 18.4803 3.35467 18.5891 3.54114C18.698 3.72761 18.8642 3.87385 19.063 3.95802C20.5507 4.70595 21.8006 5.85351 22.6726 7.27202C23.5447 8.69053 24.0043 10.3239 24 11.989C24 15.513 22 18.539 19.062 20.02C18.9283 20.0665 18.806 20.1409 18.7032 20.2382C18.6004 20.3355 18.5194 20.4536 18.4656 20.5845C18.4118 20.7155 18.3865 20.8563 18.3912 20.9978C18.3959 21.1393 18.4306 21.2782 18.493 21.4052C18.5554 21.5323 18.644 21.6447 18.7531 21.7349C18.8622 21.8252 18.9892 21.8912 19.1257 21.9287C19.2622 21.9662 19.4051 21.9743 19.5449 21.9525C19.6848 21.9307 19.8184 21.8794 19.937 21.802C23.53 19.989 26 16.277 26 11.989C26 7.70102 23.529 3.98902 19.937 2.17602C19.7659 2.08051 19.5704 2.03739 19.375 2.05202C19.3437 2.05055 19.3123 2.05055 19.281 2.05202ZM16.906 5.92602C16.6907 5.94183 16.4863 6.0269 16.3233 6.16852C16.1603 6.31014 16.0476 6.50069 16.0019 6.7117C15.9562 6.92271 15.98 7.14284 16.0698 7.33919C16.1596 7.53554 16.3105 7.69755 16.5 7.80102C18.043 8.76002 19 10.279 19 11.989C19 13.711 18.028 15.25 16.469 16.208C16.3465 16.2719 16.2386 16.3605 16.1521 16.4682C16.0655 16.5758 16.0022 16.7003 15.9662 16.8336C15.9301 16.967 15.9221 17.1064 15.9426 17.243C15.9631 17.3796 16.0117 17.5105 16.0853 17.6274C16.1588 17.7443 16.2559 17.8447 16.3702 17.9222C16.4845 17.9998 16.6137 18.0528 16.7495 18.0779C16.8853 18.1031 17.0249 18.0998 17.1594 18.0683C17.2939 18.0368 17.4204 17.9778 17.531 17.895C19.601 16.625 21 14.465 21 11.989C21 9.52802 19.613 7.35602 17.562 6.08302C17.3944 5.97598 17.1988 5.92132 17 5.92602C16.9687 5.92454 16.9373 5.92454 16.906 5.92602Z"
                    fill={selectedTheme?.textColor}
                  />
                </svg>
              ) : (
                <></>
              )}
              <audio ref={audioRef} src={currentMusic} />
            </div>
            {memorial?.birthDate && (
              <p style={paragraphStyle} className="date-section">{`${
                memorial?.birthDate?.split("-")[0] || ""
              } - ${memorial?.passedDate?.split("-")[0] || ""}`}</p>
            )}
          </div>
          <div className="profile-main-layout">
          <div className="tabs-container">
            <div className="tab-links">
              <ul className="ul-row">
                {selectedPlan !== 0 ? (
                  <>
                    <li>
                      <a
                        onClick={() => {
                          setCurrentTab("about");
                        }}
                        className={`${
                          currentTab === "about" ? "tag-active" : "tag"
                        }`}
                        style={paragraphStyle}
                      >
                        Tributes
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          setCurrentTab("life");
                        }}
                        className={`${
                          currentTab === "life" ? "tag-active" : "tag"
                        }`}
                        style={paragraphStyle}
                      >
                        About
                      </a>
                    </li>
                  </>
                ) : (
                  <></>
                )}
                <li>
                  <a
                    onClick={() => {
                      setCurrentTab("gallery");
                    }}
                    className={`${
                      currentTab === "gallery" ? "tag-active" : "tag"
                    }`}
                    style={paragraphStyle}
                  >
                    Gallery
                  </a>
                </li>
                {/*{selectedPlan !== 0 ? (
                  <li>
                    <a
                      onClick={() => {
                        setCurrentTab("stories");
                      }}
                      className={`${
                        currentTab === "stories" ? "tag-active" : "tag"
                      }`}
                      style={paragraphStyle}
                    >
                      Stories
                    </a>
                  </li>
                ) : (
                  <></>
                )}*/}
                {selectedPlan !== 0 && isAdmin() && (
                  <li>
                    <div className="">
                      <div className="custom-dropdown" ref={dropdownRef}>
                        <div
                          className="dropdown-header"
                          onClick={() => {
                            handleDropdownToggle();
                          }}
                        >
                          <label
                            className="tag-admin"
                            style={{ color: selectedTheme?.textColor }}
                            htmlFor="relationship"
                          >
                            Settings
                            <span
                              style={{ color: selectedTheme?.textColor }}
                              className="dropdown-arrow"
                            >
                              &#9662;
                            </span>
                          </label>
                        </div>
                        {dropdownOpen && (
                          <ul className="dropdown-options profile-settings-menu">
                            {settingsMenuItems.map((item) => (
                              <li
                                key={item.ref + item.title}
                                className={item.highlight ? "settings-item-highlight" : ""}
                              >
                                <span
                                  className="item-a settings-menu-link"
                                  style={
                                    item.highlight
                                      ? { color: selectedTheme?.textColor || "#5c5470" }
                                      : undefined
                                  }
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setCurrentTab(item.ref);
                                    handleDropdownToggle();
                                    if (item.ref === "themes") {
                                      navigate("/theme", {
                                        state: {
                                          from: "profile",
                                          selectedMemorial: id,
                                          slug: slug,
                                        },
                                      });
                                    }
                                  }}
                                >
                                  {item.title}
                                  {item.badge ? (
                                    <span className="settings-menu-badge">{item.badge}</span>
                                  ) : null}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </li>
                )}
                <li>
                  <a
                    onClick={() => {
                      setCurrentTab("invite");
                    }}
                    className={`${currentTab === "invite" ? "tag-active" : "tag"}`}
                    style={paragraphStyle}
                  >
                    Invite
                  </a>
                </li>
                {/*<li>
                  <a
                    onClick={() => {
                      setCurrentTab("views");
                    }}
                    className={`${currentTab === "views" ? "tag-active" : "tag"}`}
                    style={paragraphStyle}
                  >
                    Views
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      setCurrentTab("contact");
                    }}
                    className={`${currentTab === "contact" ? "tag-active" : "tag"}`}
                    style={paragraphStyle}
                  >
                    Contact Author
                  </a>
                </li>*/}
              </ul>
            </div>
          </div>

          <div className="profile-content-column">
            {showHeroSlideshow && (
              <div className="memorial-hero-slideshow-wrap">
                <GallerySlideshow
                  photos={memorial.gallery.photos}
                  intervalSeconds={memorial.gallerySlideshow.intervalSeconds || 5}
                  textColor={selectedTheme?.textColor}
                  className="memorial-hero-slideshow"
                />
              </div>
            )}
          <div className="card-container">
            {selectedTheme && cardObject[currentTab]}
            {currentTab === "invite" && (
  <Card>
    <div className="invitation-card">
    <svg
      width="102"
      height="59"
      viewBox="0 0 102 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5417 50.5417V58.9583H72.0417V50.5417C72.0417 50.5417 72.0417 33.7083 46.7917 33.7083C21.5417 33.7083 21.5417 50.5417 21.5417 50.5417ZM34.1667 12.6667C34.1667 10.1697 34.9071 7.72877 36.2944 5.65259C37.6816 3.57642 39.6534 1.95825 41.9603 1.00269C44.2672 0.0471344 46.8057 -0.202883 49.2547 0.284256C51.7037 0.771394 53.9533 1.97381 55.7189 3.73945C57.4845 5.50508 58.6869 7.75464 59.1741 10.2037C59.6612 12.6527 59.4112 15.1911 58.4556 17.498C57.5001 19.805 55.8819 21.7767 53.8057 23.164C51.7296 24.5512 49.2887 25.2917 46.7917 25.2917C43.4433 25.2917 40.2321 23.9615 37.8644 21.5939C35.4968 19.2262 34.1667 16.015 34.1667 12.6667ZM20.7 33.9608C18.3996 36.0831 16.545 38.6424 15.2444 41.4892C13.9438 44.336 13.2233 47.4134 13.125 50.5417V58.9583H0.5V50.5417C0.5 50.5417 0.499992 36.0229 20.7 33.9608ZM25.75 0.0416689C27.0215 0.0424298 28.2851 0.2412 29.4954 0.630835C27.0333 4.1615 25.7132 8.36231 25.7132 12.6667C25.7132 16.971 27.0333 21.1718 29.4954 24.7025C28.2851 25.0921 27.0215 25.2909 25.75 25.2917C22.4016 25.2917 19.1904 23.9615 16.8228 21.5939C14.4551 19.2262 13.125 16.015 13.125 12.6667C13.125 9.31831 14.4551 6.10709 16.8228 3.73945C19.1904 1.3718 22.4016 0.0416689 25.75 0.0416689ZM67.8333 21.0833H80.4583V8.45834H88.875V21.0833H101.5V29.5H88.875V42.125H80.4583V29.5H67.8333V21.0833Z"
        fill={selectedTheme?.textColor || "#5c5470"}
        fill-opacity="0.5"
      />
    </svg>
      <p className="invitation-card-text">
        Invite {memorial?.firstName}'s family and friends
      </p>
      {memorialShareUrl && (
        <p
          style={{ ...paragraphStyle, fontSize: "0.85rem", marginBottom: 12, wordBreak: "break-all" }}
        >
          Share link: {formatShareUrlForDisplay(memorialShareUrl)}
        </p>
      )}
      <Button
        onClick={() => {
          if (!memorial?.privacy?.onlyme) {
            setIsPrivate(false);
            setOpenShareModal(true);
            handleShareModalOpen();
          } else {
            setIsPrivate(true);
            setOpenShareModal(true);
          }
        }}
        bgColor={selectedTheme?.textColor || "#5c5470"}
        text="Invite"
      />
      <div className="social-media-fb">
         <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill={selectedTheme?.textColor || "#5c5470"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.75 0.5C17.783 0.5 18.6662 0.866753 19.3997 1.60026C20.1332 2.33377 20.5 3.21701 20.5 4.25V16.75C20.5 17.783 20.1332 18.6662 19.3997 19.3997C18.6662 20.1332 17.783 20.5 16.75 20.5H14.3021V12.7526H16.8932L17.2839 9.73177H14.3021V7.80469C14.3021 7.31858 14.4041 6.95399 14.6081 6.71094C14.8121 6.46788 15.2092 6.34635 15.7995 6.34635L17.388 6.33333V3.63802C16.8411 3.5599 16.0686 3.52083 15.0703 3.52083C13.8898 3.52083 12.9457 3.86806 12.2383 4.5625C11.5308 5.25694 11.1771 6.23785 11.1771 7.50521V9.73177H8.57292V12.7526H11.1771V20.5H4.25C3.21701 20.5 2.33377 20.1332 1.60026 19.3997C0.866753 18.6662 0.5 17.783 0.5 16.75V4.25C0.5 3.21701 0.866753 2.33377 1.60026 1.60026C2.33377 0.866753 3.21701 0.5 4.25 0.5H16.75Z"
              fill={selectedTheme?.textColor || "#5c5470"}
            />
          </svg>
        <a
          style={paragraphStyle}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(memorialShareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Share on Facebook
        </a>
      </div>
    </div>
  </Card>
)}

{currentTab === "views" && (
  <Card>
    <div className="invitation-card">
      <div className="views-card-top">
        <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.9396 15.66C29.7634 12.6176 27.7216 9.98662 25.0664 8.09209C22.4112 6.19756 19.2591 5.12257 15.9996 5C12.7401 5.12257 9.58796 6.19756 6.93278 8.09209C4.27759 9.98662 2.23574 12.6176 1.05957 15.66C0.980142 15.8797 0.980142 16.1203 1.05957 16.34C2.23574 19.3824 4.27759 22.0134 6.93278 23.9079C9.58796 25.8024 12.7401 26.8774 15.9996 27C19.2591 26.8774 22.4112 25.8024 25.0664 23.9079C27.7216 22.0134 29.7634 19.3824 30.9396 16.34C31.019 16.1203 31.019 15.8797 30.9396 15.66ZM15.9996 25C10.6996 25 5.09957 21.07 3.06957 16C5.09957 10.93 10.6996 7 15.9996 7C21.2996 7 26.8996 10.93 28.9296 16C26.8996 21.07 21.2996 25 15.9996 25Z"
                      fill="#5C5470"
                    />
                    <path
                      d="M16 10C14.8133 10 13.6533 10.3519 12.6666 11.0112C11.6799 11.6705 10.9109 12.6075 10.4567 13.7039C10.0026 14.8003 9.88378 16.0067 10.1153 17.1705C10.3468 18.3344 10.9182 19.4035 11.7574 20.2426C12.5965 21.0818 13.6656 21.6532 14.8295 21.8847C15.9933 22.1162 17.1997 21.9974 18.2961 21.5433C19.3925 21.0892 20.3295 20.3201 20.9888 19.3334C21.6481 18.3467 22 17.1867 22 16C22 14.4087 21.3679 12.8826 20.2426 11.7574C19.1174 10.6321 17.5913 10 16 10ZM16 20C15.2089 20 14.4355 19.7654 13.7777 19.3259C13.1199 18.8864 12.6072 18.2616 12.3045 17.5307C12.0017 16.7998 11.9225 15.9956 12.0769 15.2196C12.2312 14.4437 12.6122 13.731 13.1716 13.1716C13.731 12.6122 14.4437 12.2312 15.2196 12.0769C15.9956 11.9225 16.7998 12.0017 17.5307 12.3045C18.2616 12.6072 18.8864 13.1199 19.3259 13.7777C19.7654 14.4355 20 15.2089 20 16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20Z"
                      fill={selectedTheme?.textColor || "#5c5470"}
                    />
                  </svg>       
        <p style={paragraphStyle} className="views-top-text">
          {memorial?.visitors.length} Views
        </p>
      </div>
      <div className="views-card-content">
        <p style={paragraphStyle} className="views-card-mainText">
          This website is administered by:
        </p>
        <p style={paragraphStyle} className="views-card-secondary">
          willalwaysloveuTech@gmail.com
        </p>
      </div>
    </div>
  </Card>
)}

{currentTab === "contact" && (
  <Card>
    <div className="suggestion-card">
      <p style={paragraphStyle}>Have a suggestion?</p>
      <Link to="/contactus">
        <Button
          bgColor={selectedTheme?.textColor || "#5c5470"}
          text="Contact Us"
        />
      </Link>
    </div>
  </Card>
)}
            {/*<div className="side-section">
              {selectedPlan !== 0 && (
                <Card>
                  <div className="invitation-card">
                    <svg
                      width="102"
                      height="59"
                      viewBox="0 0 102 59"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.5417 50.5417V58.9583H72.0417V50.5417C72.0417 50.5417 72.0417 33.7083 46.7917 33.7083C21.5417 33.7083 21.5417 50.5417 21.5417 50.5417ZM34.1667 12.6667C34.1667 10.1697 34.9071 7.72877 36.2944 5.65259C37.6816 3.57642 39.6534 1.95825 41.9603 1.00269C44.2672 0.0471344 46.8057 -0.202883 49.2547 0.284256C51.7037 0.771394 53.9533 1.97381 55.7189 3.73945C57.4845 5.50508 58.6869 7.75464 59.1741 10.2037C59.6612 12.6527 59.4112 15.1911 58.4556 17.498C57.5001 19.805 55.8819 21.7767 53.8057 23.164C51.7296 24.5512 49.2887 25.2917 46.7917 25.2917C43.4433 25.2917 40.2321 23.9615 37.8644 21.5939C35.4968 19.2262 34.1667 16.015 34.1667 12.6667ZM20.7 33.9608C18.3996 36.0831 16.545 38.6424 15.2444 41.4892C13.9438 44.336 13.2233 47.4134 13.125 50.5417V58.9583H0.5V50.5417C0.5 50.5417 0.499992 36.0229 20.7 33.9608ZM25.75 0.0416689C27.0215 0.0424298 28.2851 0.2412 29.4954 0.630835C27.0333 4.1615 25.7132 8.36231 25.7132 12.6667C25.7132 16.971 27.0333 21.1718 29.4954 24.7025C28.2851 25.0921 27.0215 25.2909 25.75 25.2917C22.4016 25.2917 19.1904 23.9615 16.8228 21.5939C14.4551 19.2262 13.125 16.015 13.125 12.6667C13.125 9.31831 14.4551 6.10709 16.8228 3.73945C19.1904 1.3718 22.4016 0.0416689 25.75 0.0416689ZM67.8333 21.0833H80.4583V8.45834H88.875V21.0833H101.5V29.5H88.875V42.125H80.4583V29.5H67.8333V21.0833Z"
                        fill={selectedTheme?.textColor || "#5c5470"}
                        fill-opacity="0.5"
                      />
                    </svg>
                    <p className="invitation-card-text">
                      Invite {memorial?.firstName}'s family and friends
                    </p>



                    <Button
        onClick={() => {
        
          if (!memorial?.privacy?.onlyme) {
            setIsPrivate(false); // Perfil público
            setOpenShareModal(true); // Abre el modal con opciones de compartir
            handleShareModalOpen();
          } else {
            setIsPrivate(true); // Perfil privado
            setOpenShareModal(true); // Abre el modal con el mensaje de advertencia
          }
        }}
        bgColor={selectedTheme?.textColor || "#5c5470"}
        text="Invite"
      />




                    <div className="social-media-fb">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill={selectedTheme?.textColor || "#5c5470"}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.75 0.5C17.783 0.5 18.6662 0.866753 19.3997 1.60026C20.1332 2.33377 20.5 3.21701 20.5 4.25V16.75C20.5 17.783 20.1332 18.6662 19.3997 19.3997C18.6662 20.1332 17.783 20.5 16.75 20.5H14.3021V12.7526H16.8932L17.2839 9.73177H14.3021V7.80469C14.3021 7.31858 14.4041 6.95399 14.6081 6.71094C14.8121 6.46788 15.2092 6.34635 15.7995 6.34635L17.388 6.33333V3.63802C16.8411 3.5599 16.0686 3.52083 15.0703 3.52083C13.8898 3.52083 12.9457 3.86806 12.2383 4.5625C11.5308 5.25694 11.1771 6.23785 11.1771 7.50521V9.73177H8.57292V12.7526H11.1771V20.5H4.25C3.21701 20.5 2.33377 20.1332 1.60026 19.3997C0.866753 18.6662 0.5 17.783 0.5 16.75V4.25C0.5 3.21701 0.866753 2.33377 1.60026 1.60026C2.33377 0.866753 3.21701 0.5 4.25 0.5H16.75Z"
                          fill={selectedTheme?.textColor || "#5c5470"}
                        />
                      </svg>
                      <a
                        style={paragraphStyle}
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(memorialShareUrl)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Share on Facebook
                      </a>
                    </div>
                  </div>
                </Card>
              )}
              {selectedPlan !== 0 && (
                <Card>
                  <div className="invitation-card">
                    <p style={paragraphStyle} className="invitation-card-text">
                      Notification preferences
                    </p>
                    <div className="action-buttons">
                      <a className="action-btn">
                        <TiLeaf
                          color={selectedTheme?.textColor || "#5c5470"}
                          size="2.5em"
                        />
                      </a>
                      <a className="action-btn">
                        <HiOutlineCake
                          color={selectedTheme?.textColor || "#5c5470"}
                          size="2.3em"
                        />
                      </a>
                      <a className="action-btn">
                        <BsChatLeftHeart
                          color={selectedTheme?.textColor || "#5c5470"}
                          size="2.1em"
                        />
                      </a>
                    </div>
                    <Button
                      disabled={!user || !isAdmin()}
                      bgColor={selectedTheme?.textColor || "#5c5470"}
                      onClick={handleClickOpen}
                      text="Manage"
                    />
                  </div>
                </Card>
              )}
              <Card>
                <div className="invitation-card">
                  <div className="views-card-top">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.9396 15.66C29.7634 12.6176 27.7216 9.98662 25.0664 8.09209C22.4112 6.19756 19.2591 5.12257 15.9996 5C12.7401 5.12257 9.58796 6.19756 6.93278 8.09209C4.27759 9.98662 2.23574 12.6176 1.05957 15.66C0.980142 15.8797 0.980142 16.1203 1.05957 16.34C2.23574 19.3824 4.27759 22.0134 6.93278 23.9079C9.58796 25.8024 12.7401 26.8774 15.9996 27C19.2591 26.8774 22.4112 25.8024 25.0664 23.9079C27.7216 22.0134 29.7634 19.3824 30.9396 16.34C31.019 16.1203 31.019 15.8797 30.9396 15.66ZM15.9996 25C10.6996 25 5.09957 21.07 3.06957 16C5.09957 10.93 10.6996 7 15.9996 7C21.2996 7 26.8996 10.93 28.9296 16C26.8996 21.07 21.2996 25 15.9996 25Z"
                        fill="#5C5470"
                      />
                      <path
                        d="M16 10C14.8133 10 13.6533 10.3519 12.6666 11.0112C11.6799 11.6705 10.9109 12.6075 10.4567 13.7039C10.0026 14.8003 9.88378 16.0067 10.1153 17.1705C10.3468 18.3344 10.9182 19.4035 11.7574 20.2426C12.5965 21.0818 13.6656 21.6532 14.8295 21.8847C15.9933 22.1162 17.1997 21.9974 18.2961 21.5433C19.3925 21.0892 20.3295 20.3201 20.9888 19.3334C21.6481 18.3467 22 17.1867 22 16C22 14.4087 21.3679 12.8826 20.2426 11.7574C19.1174 10.6321 17.5913 10 16 10ZM16 20C15.2089 20 14.4355 19.7654 13.7777 19.3259C13.1199 18.8864 12.6072 18.2616 12.3045 17.5307C12.0017 16.7998 11.9225 15.9956 12.0769 15.2196C12.2312 14.4437 12.6122 13.731 13.1716 13.1716C13.731 12.6122 14.4437 12.2312 15.2196 12.0769C15.9956 11.9225 16.7998 12.0017 17.5307 12.3045C18.2616 12.6072 18.8864 13.1199 19.3259 13.7777C19.7654 14.4355 20 15.2089 20 16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20Z"
                        fill={selectedTheme?.textColor || "#5c5470"}
                      />
                    </svg>

                    <p style={paragraphStyle} className="views-top-text">
                      {memorial?.visitors.length} Views
                    </p>
                  </div>
                  <div className="views-card-content">
                    <p style={paragraphStyle} className="views-card-mainText">
                      This website is administered by:
                    </p>
                    <p style={paragraphStyle} className="views-card-secondary">
                      willalwaysloveuTech@gmail.com
                    </p>
                    
                  </div>
                  <Button
                    style={{ width: "fit-content", padding: "20px" }}
                    text="Contact to Author"
                    onClick={() => handleCopyClick(owner)}
                    bgColor={selectedTheme?.textColor || "#5c5470"}
                  />
                </div>
              </Card>

              <Card>
                <div className="suggestion-card">
                  <p style={paragraphStyle}>Have a Suggestions?</p>
                  <Link to="/contactus">
                    <Button
                      bgColor={selectedTheme?.textColor || "#5c5470"}
                      text="Contact Us"
                    />
                  </Link>
                </div>
              </Card>
            </div>
          */}
          </div>
          </div>
          </div>
          {open && (
            <Dialog
              open={open}
              TransitionComponent={Transition}
              keepMounted
              fullWidth
              sx={{
                backdropFilter: "blur(5px) sepia(5%)",
              }}
              // 👇 Props passed to Paper (modal content)
              PaperProps={{ sx: { borderRadius: "15px", overflow: "hidden" } }}
              maxWidth="md"
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
            >
              <p className="dialog-header">{"Notification Preference"}</p>
              <div className="dialog-content">
                <div className="email-section">
                  <p className="youremail">Your Email:</p>
                  <div className="email-content">
                    <p className="email-p">{user?.email}</p>
                    {/* <a>Change</a> */}
                  </div>
                </div>
                <div className="notification-section">
                  <p className="youremail">Receive Notification:</p>
                  <div className="checkbox-container">
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmark"></span>
                      <a className="action-btn">
                        <TiLeaf size="2.5em" />
                      </a>
                      On new posts from other guests
                    </label>
                  </div>
                  <div className="checkbox-container special">
                    <label className="custom-checkbox special">
                      <input
                        type="checkbox"
                        checked={isChecked1}
                        onChange={handleCheckboxChange1}
                      />
                      <span className="checkmark"></span>
                      <a className="action-btn">
                        <HiOutlineCake size="2.3em" />
                      </a>
                      On {memorial?.firstName}’s Birthday
                    </label>
                  </div>
                  <div className="checkbox-container special">
                    <label className="custom-checkbox special">
                      <input
                        type="checkbox"
                        checked={isChecked2}
                        onChange={handleCheckboxChange2}
                      />
                      <span className="checkmark"></span>
                      <a className="action-btn">
                        <BsChatLeftHeart size="2.1em" />
                      </a>
                      On day of passing
                    </label>
                  </div>
                </div>
              </div>
              <div className="dialog-action">
                <div className="checkbox-container">
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={isChecked3}
                      onChange={handleCheckboxChange3}
                    />
                    <span className="checkmark"></span>
                    Unsubscribe from all e-mails
                  </label>
                </div>
                <Button
                  isLoading={nloading}
                  bgColor={selectedTheme?.textColor || "#5c5470"}
                  onClick={() => {
                    handleSavePreferences();
                  }}
                  text="Save"
                />
              </div>
            </Dialog>
          )}
          {openShareModal && (
            <Dialog
              open={openShareModal}
              TransitionComponent={Transition}
              keepMounted
              fullWidth
              sx={{
                backdropFilter: "blur(5px) sepia(5%)",
              }}
              // 👇 Props passed to Paper (modal content)
              PaperProps={{ sx: { borderRadius: "15px", overflow: "hidden" } }}
              maxWidth="md"
              onClose={handleShareModalClose}
              aria-describedby="alert-dialog-slide-description"
            >

            {/* 🔹 Mostrar mensaje de advertencia si el perfil es privado */}
         {isPrivate ? (
           <>
             <p className="dialog-header">Notice</p>
             <div className="dialog-content">
               <p>The profile is currently private and cannot be shared, change to “All visitors can view and contribute” in privacy settings.</p>
             </div>
             <div className="dialog-action">
               <Button
                 bgColor={selectedTheme?.textColor || "#5c5470"}
                 onClick={() => setOpenShareModal(false)}
                 text="Close"
               />
             </div>
           </>
         ) : (
           <>
             {/* 🔹 Opciones de compartir si el perfil es público */}
              <p className="dialog-header">{"Invite Via:"}</p>
              <div className="dialog-content">
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",

                      gap: "20px",
                      justifyItems: "start",
                      justifyContent: "flex-start",
                      alignContent: "start",
                      alignItems: "start",
                      // border:"1px solid red",
                      padding: "0px 0px",
                    }}
                  >
                   
                    <div className="social-media-fb">
                      <Facebook
                        htmlColor={selectedTheme?.textColor || "#5c5470"}
                        size="2.5em"
                      />
                      <a
                        style={paragraphStyle}
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(memorialShareUrl)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Share on Facebook
                      </a>
                    </div>
                    <div className="social-media-fb">
                      <ContentCopy
                        htmlColor={selectedTheme?.textColor || "#5c5470"}
                        size="2.5em"
                      />
                      <a
                            style={paragraphStyle}
                            onClick={(event) => {
                              event.preventDefault(); // Evita que la página se recargue o haga scroll
                              const link = memorialShareUrl;
                              handleCopyClick(link);
                            }}
                            href="#"
                            role="button"
                            tabIndex="0"
                            rel="noopener noreferrer"
                          >
                             Copy Link
                          </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dialog-action">
                <Button
                  // isLoading={nloading}
                  bgColor={selectedTheme?.textColor || "#5c5470"}
                  onClick={() => {
                    // handleSavePreferences();
                    handleShareModalClose();
                  }}
                  text="Close"
                />
              </div>
              </>
             )}
            </Dialog>
          )}
          {isAdmin() &&
            pendingTributeCount > 0 &&
            currentTab !== "pendingTributes" && (
              <PendingTributesBanner
                count={pendingTributeCount}
                preview={pendingTributesList[0]?.description}
                memorialName={`${memorial?.firstName || ""} ${memorial?.lastName || ""}`.trim()}
                onReview={() => setCurrentTab("pendingTributes")}
              />
            )}
        </>
      ) : mainLoader ? (
        <div className="loading-state">
          <ThreeDots
            height="50"
            width="50"
            radius="9"
            color="#5c5470"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      ) : mainError || !memorial?.publicVisibility || !accessWithToken ? (
        <div className="loading-state">
          <h1>This memorial is private.</h1>
        </div>
      ) : null}
    </div>
  );
};

export default Profile;
